module.exports = __webpack_public_path__ + "img/bingo_ball-69.7332de3e.png";